import { QuestionCategoryInsert, QuestionCategoryDelete, QuestionCategoryUpdate, QuestionCategoryGetById, QuestionCategoryGetList, QuestionCategoryGetPageList } from "@/api/questioncategory/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 新增
    QuestionCategoryInsert(context, payload) {
        return new Promise((resolve, reject) => {
            
            
            QuestionCategoryInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    QuestionCategoryUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            QuestionCategoryUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    QuestionCategoryGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            QuestionCategoryGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    QuestionCategoryGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            QuestionCategoryGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    QuestionCategoryGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            QuestionCategoryGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}